var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackCashMoneySvgrepocom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 31.5625V37.875",
    stroke: "#100808",
    strokeWidth: 5.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 63.125V69.4375",
    stroke: "#100808",
    strokeWidth: 5.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1875 63.125H53.6562C57.1281 63.125 59.9688 60.2844 59.9688 56.8125C59.9688 53.3406 57.1281 50.5 53.6562 50.5H47.3438C43.8719 50.5 41.0312 47.6594 41.0312 44.1875C41.0312 40.7156 43.8719 37.875 47.3438 37.875H56.8125",
    stroke: "#100808",
    strokeWidth: 5.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 18.9375C67.8594 18.9375 82.0625 33.1406 82.0625 50.5C82.0625 67.8594 67.8594 82.0625 50.5 82.0625C33.1406 82.0625 18.9375 67.8594 18.9375 50.5V41.0312",
    stroke: "#100808",
    strokeWidth: 5.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5625 53.6562L18.9375 41.0312L6.3125 53.6562",
    stroke: "#100808",
    strokeWidth: 5.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 6.3125C74.8031 6.3125 94.6875 26.1969 94.6875 50.5C94.6875 74.8031 74.8031 94.6875 50.5 94.6875",
    stroke: "#100808",
    strokeWidth: 5.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackCashMoneySvgrepocom);
export default __webpack_public_path__ + "static/media/back-cash-money_svgrepo.com.d109eb8da3691cb53e1f158a21b957a2.svg";
export { ForwardRef as ReactComponent };